export default __webpack_public_path__ + "static/media/sobretarima2.f070d73a.png";